/**
 * This is the entry-point for all scripts
 * Note: CSS files are now loaded as separate webpack entries for better caching
 */
import $ from "jquery";

import Navigation from "./navigation";
import Footer from "./footer";
import LandingPage from "./landing-page";

import "./buttons";

import HomeHero from "../../components/home-hero/home-hero";
import videoPlayer from "./videoPlayer";
import StandoutStats from "../../components/standout-stats/standout-stats";
import CTATiles from "../../components/cta-tiles/cta-tiles";
import NumberedCardCarousel from "../../components/numbered-card-carousel/numbered-card-carousel";
import TestimonialCarousel from "../../components/testimonial-carousel/testimonial-carousel";
import GalleryCarousel from "../../components/gallery-carousel/gallery-carousel";
import StandoutList from "../../components/standout-list/standout-list";
import NumberedTiles from "../../components/numbered-tiles/numbered-tiles";
import SideBySideCarousel from "../../components/side-by-side-carousel/side-by-side-carousel";
import TextSection from "../../components/text-section/text-section";
import Vacancies from "../../components/vacancies/vacancies";
import FormSection from "../../components/form/form";
import StatBlocks from "../../components/stat-blocks/stat-blocks";
import LargeLogoCarousel from "../../components/large-logo-carousel/large-logo-carousel";
import TilesWithIcons from "../../components/tiles-with-icons/tiles-with-icons";
import FormSectionHubspot from "../../components/form-hubspot/form-hubspot";
import FormFoundation from "../../components/form-foundation/form-foundation";

$(function () {
  new Navigation();
  new Footer();
  if ($(".page-template-template-landing-page")[0]){
    new LandingPage();
  };

  $("section.home-hero").each(function () {
    new HomeHero($(this));
  });

  $(".module-video-player").each(function () {
    new videoPlayer($(this));
  });

  $("section.standout-stats").each(function () {
    new StandoutStats();
  });

  $("section.cta-tiles").each(function () {
    new CTATiles($(this));
  });

  $("section.tiles-with-icons").each(function () {
    new TilesWithIcons($(this));
  });

  $("section.numbered-card-carousel").each(function () {
    new NumberedCardCarousel($(this));
  });

  $("section.testimonial-carousel").each(function () {
    new TestimonialCarousel($(this));
  });

  $("section.gallery-carousel").each(function () {
    new GalleryCarousel($(this));
  });

  $("section.standout-list").each(function () {
    new StandoutList($(this));
  });

  $("section.numbered-tiles").each(function () {
    new NumberedTiles($(this));
  });

  $("section.side-by-side-carousel").each(function () {
    new SideBySideCarousel($(this));
  });

  $("section.text-section").each(function () {
    new TextSection($(this));
  });

  $("section.vacancies").each(function () {
    new Vacancies($(this));
  });

  $("section.form").each(function () {
    new FormSection($(this));
  });

  $("section.stat-blocks").each(function () {
    new StatBlocks($(this));
  });

  $("section.large-logo-carousel").each(function () {
    new LargeLogoCarousel($(this));
  });

  $("section.form-hubspot").each(function () {
    new FormSectionHubspot($(this));
  });

  $("section.form-foundation").each(function () {
    new FormFoundation($(this));
  });

  // Load Zendesk widget (skip for AU version).
  var htmlLang = document.documentElement.getAttribute("lang");
  if (htmlLang !== "en-AU") {
    var zdscript = document.createElement("script");
    zdscript.type = "text/javascript";
    zdscript.async = true;
    zdscript.defer = true;
    zdscript.id = "ze-snippet";
    zdscript.src =
      "https://static.zdassets.com/ekr/snippet.js?key=1fc5c407-8a75-437b-9784-eb704fed5ab3";

    document.body.appendChild(zdscript);

    window.zESettings = {
      cookies: false,
    };
  }

  if($('#modal').length) {
    $('html').css('overflow', 'hidden');
    $('#modal svg, #modal .close').on('click', function() {
      $('#modal').fadeOut();
      $('html').css('overflow', 'visible');
    })
  }

//  function replaceApostrophe() {
//     function tryReplace() {
//       const $el = $('.sweet-alert p');
//       if ($el.length) {
//         $el.each(function () {
//           const html = $(this).html();
//           if (html.includes('&#039;')) {
//             $(this).html(html.replace('&#039;', "'"));
//             console.log('Replaced apostrophes in', selector);
//           }
//         });
//       } else {
//         // Retry every 200ms until the element exists
//         console.log('Element not found, retrying...');
//         setTimeout(tryReplace, 200);
//       }
//     }

//     tryReplace();
//   }
//   replaceApostrophe()
});
